import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Home/AppHome.css";
import "../Admin/Admin.css";
import Header2 from "./Header2";
import { useNavigate } from 'react-router-dom';
import DialogBoxs from "./DialogBoxs";

const BASE_URL = "https://gym-invoice-back.onrender.com";

function AttendanceScanner() {
  const [scannedId, setScannedId] = useState("");
  const [status, setStatus] = useState(""); // "success", "error", "already"
  const [message, setMessage] = useState("");
  const [dialog, setDialog] = useState({
    show: false,
    title: "",
    message: "",
    type: "confirm",
    onConfirm: null,
  });

  const [memberName, setMemberName] = useState("");
  const navigate = useNavigate();


  // Step 1: Fetch member and show confirm dialog
  const handleAddClick = async () => {
    const memberId = scannedId.trim();
    if (!memberId) return;

    try {
      const res = await axios.get(
        `https://gym-invoice-back.onrender.com/api/members/by-member-id/${memberId}`
      );

      if (res.data && res.data.name) {
        // CHECK ACTIVE STATUS
         if (res.data.membershipStatus !== "ACTIVE") {
          setStatus("error");
          setMessage(`Membership is not active.`);
          return; // STOP HERE
        }

        // IF ACTIVE — PROCEED
        setMemberName(res.data.name);

        setDialog({
          show: true,
          type: "confirm",
          message: `${res.data.name}, do you want to mark your attendance?`,
          onConfirm: confirmAttendance,
        });

      } else {
        setStatus("error");
        setMessage("Member not found.");
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
      setMessage("Failed to fetch member info.");
    }
  };

  // Step 2: Confirm attendance
  const confirmAttendance = async () => {
    const memberId = scannedId.trim();

    try {
      // 1️⃣ Mark attendance
      await axios.post(
        `${BASE_URL}/api/attendance/mark`,
          {
                memberId: memberId,
                branchCode: "KB"
              }
      );

      // 2️⃣ Check payment / membership cycle
      const res = await axios.get(
        `${BASE_URL}/api/payments/attendance-status/${memberId}`
      );

      // 3️⃣ Navigate based on payment status
      if (res.data.status === "EXPIRED") {
        navigate("/membership-expired", { state: res.data });

      } else if (res.data.status === "DUE_SOON") {
        navigate("/payment-warning", { state: res.data });

      } else {
        navigate("/mark-successful");
      }

      setStatus("success");
      setMessage("Attendance marked successfully");

    } catch (error) {
      console.error(error);

      if (error.response && error.response.status === 409) {
        setStatus("already");
        setMessage("Attendance already marked today.");
      } else {
        setStatus("error");
        setMessage("Failed to mark attendance.");
      }
    }

    setScannedId("");
    setMemberName("");
  };


  return (
    <div className="dashboard">
<Header2/>

      <div className="payment-wrapper">
        <div className="payment-container">
          <h2>⏰ Mark Member Attendance [Kesbawe]</h2>

          <div className="search-box">
            <input
              type="text"
              value={scannedId}
              autoFocus
              onChange={(e) => setScannedId(e.target.value)}
              placeholder="Type Your Member ID Here"
            />
            <button onClick={handleAddClick}>ADD</button>
          </div>

          {/* Status Messages */}
          <div style={{ marginTop: "20px" }}>
            {status === "success" && <div style={{ color: "green" }}>{message}</div>}
            {status === "already" && <div style={{ color: "orange" }}>{message}</div>}
            {status === "error" && <div style={{ color: "red" }}>{message}</div>}
          </div>
        </div>
      </div>

      {/* Reusable Dialog */}
      <DialogBoxs dialog={dialog} setDialog={setDialog} />
    </div>
  );
}

export default AttendanceScanner;
